module.exports = __webpack_public_path__ + "img/home-serve3.786b5bb9.png";